import { StandardTabs } from '@brandfolder/react';
import React, { FunctionComponent } from 'react';

import AssetDetails from '@components/asset/modal/tabs/workflow/asset_details/main';

import '../styles/_asset_details_tabs.scss';

interface AssetDetailsProps {
  approver: boolean;
  asset: {
    id : string;
    attributes: {
      activeCdnTraces: number;
      approved: boolean;
      availability: string;
      /* eslint-disable @typescript-eslint/naming-convention */
      availability_end: string;
      availability_start: string;
      /* eslint-enable @typescript-eslint/naming-convention */
    };
  };
  displayAssetStatus: boolean;
  refreshAsset: () => void; // probably not correct function signatures
  setAsset: () => void;
  updateFetchControllers: () => void;
}

interface AssetDetailsTabsProps {
  assetDetailsProps: AssetDetailsProps;
}

export const AssetDetailsTabs: FunctionComponent<AssetDetailsTabsProps> = ({ assetDetailsProps }) => {
  const assetAvailabilityPanel = <AssetDetails {...assetDetailsProps} />;

  if (!BFG.hasFeature('rollout_asset_history_log')) {
    return assetAvailabilityPanel;
  }

  return (
    <StandardTabs
      caption={bfTranslate('Select between asset availability and history log')}
      id="asset-details-tabs"
      showUnderline
      tabs={[{
        tabButton: bfTranslate('Asset availability'),
        tabPanel: assetAvailabilityPanel
      }, {
        tabButton: bfTranslate('Asset history'),
        tabPanel: 'TODO'
      }]}
    />
  );
};
